import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import cx from 'classnames';
import { Button, FormGroup, ControlLabel } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

// Component
import Image from '../WhyHostFormBlock1/Image/Image';
import CommonFormComponent from '../../../CommonField/CommonFormComponent';
import MultiLanguageInput from '../../MultiLanguageInput/MultiLanguageInput';

// helpers
import messages from '../../../../locale/messages';
import submit from './submit';
import validate from './validate';

// style
import s from './WhyHostFormBlock7.css';
import cs from '../../../../components/commonStyle.css';

class WhyHostFormBlock7 extends Component {

  constructor(props) {
    super(props);
    this.success = this.success.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleFieldChange(fieldName, value) {
    const { dispatch } = this.props;
    dispatch(change('WhyHostForm', fieldName, value));
  }

  async success(file, fromServer) {
    const { change } = this.props;
    await change('image', fromServer && fromServer.file.filename);
  }

  render() {
    const { error, handleSubmit, submitting, reviewId, image, imageloader, formValues } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(cs.adminContentPadding)}>
        <div className={s.sectionCenter}>
          <div className={cs.commonAdminBorderSection}>
            <h1 className={s.headerTitle}><FormattedMessage {...messages.WhyBecomeOwnerBlock6} /></h1>
            <form onSubmit={handleSubmit(submit)}>
              {error && <strong>{formatMessage(error)}</strong>}
              <FormGroup className={cs.space3}>
                <ControlLabel className={s.labelTextNew}>
                  <FormattedMessage {...messages.name} />
                </ControlLabel>
                <MultiLanguageInput
                  baseField="userName"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={cs.space3}>
                <ControlLabel className={s.labelTextNew}>
                  <FormattedMessage {...messages.reviewContentLabel} />
                </ControlLabel>
                <MultiLanguageInput
                  baseField="reviewContent"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <div className={cx(s.siteContainer)}>
                  <label><FormattedMessage {...messages.imageLabel} /></label>
                  <Image image={image} fieldName={"image"} loader={imageloader} />
                </div>
              </FormGroup>

              {reviewId && <Field
                name="isEnable"
                inputClass={cx(cs.formControlSelect, 'commonAdminSelect')}
                component={CommonFormComponent}
                label={formatMessage(messages.status)}
              >
                <option value={true}>{formatMessage(messages.enableLabel)}</option>
                <option value={false}>{formatMessage(messages.disableLabel)}</option>
              </Field>}
              <div className={cx(cs.textAlignRight, 'textAlignLeftRtl', cs.spaceTop3)}>
                <Button className={cx(cs.btnPrimary, cs.btnLarge)} type="submit" disabled={submitting}>
                  <FormattedMessage {...messages.save} />
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

}

WhyHostFormBlock7 = reduxForm({
  form: 'WhyHostForm',
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(WhyHostFormBlock7);


const selector = formValueSelector('WhyHostForm');

const textFields = ['userName', 'reviewContent'];
const languages = ['', '_en', '_fr', '_it', '_pt'];

const mapState = (state) => {
  const formValues = {};
  textFields.forEach(field => {
    languages.forEach(lang => {
      formValues[`${field}${lang}`] = selector(state, `${field}${lang}`);
    });
  });
  
  return {
    formValues,
    image: selector(state, 'image'),
    imageloader: state.loader.image
  };
};

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(WhyHostFormBlock7)));